import { type ReactNode, useMemo, useRef } from 'react';

import {
  GroupedAutocompleteContext,
  type GroupedAutocompleteContextValue,
} from './context';
import type { GroupedAutocompleteItem } from './types';

type GroupedAutocompleteRootProps = {
  activeGroup: string | null;
  onActiveGroupChange: (group: string | null) => void;
  selectedItems: Record<string, string[]>;
  onSelectedItemsChange: (selectedItems: Record<string, string[]>) => void;
  children: ReactNode;
};

export const GroupedAutocompleteRoot = ({
  activeGroup,
  onActiveGroupChange,
  selectedItems,
  onSelectedItemsChange,
  children,
}: GroupedAutocompleteRootProps) => {
  const groupItemsRef = useRef<GroupedAutocompleteItem[]>([]);

  const ctx: GroupedAutocompleteContextValue = useMemo(
    () => ({
      activeGroup,
      onActiveGroupChange,
      selectedItems,
      onSelectedItemsChange,
      groupItemsRef,
    }),
    [activeGroup, onActiveGroupChange, selectedItems, onSelectedItemsChange],
  );

  return (
    <GroupedAutocompleteContext.Provider value={ctx}>
      {children}
    </GroupedAutocompleteContext.Provider>
  );
};
